import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { IS_DEV_MODE } from '@/config/env';
import { enabledLanguages, resources } from '@/i18n';

import { StorageKeysEnum } from '@/enums/storageKeys.enum';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: enabledLanguages,
    debug: IS_DEV_MODE,
    detection: {
      order: ['localStorage', 'cookie'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: StorageKeysEnum.i18nextLng,
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });
